import styled from 'styled-components'



export const ContentModalPop = styled.div`
    height:100%;
    display:flex;
    flex-direction:column;
    justify-content:space-between;
    align-items:center;
    font-weight:bold;

    svg {
        color:orange;
        font-size:40px;
    }
`
export const FlexButtonDiv = styled.div`
    gap:20px;
    width:60%;
    display:flex;
    
    
`